import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Brushaway, BrushawayBody, BrushawayFooter, BrushawayHeader } from '@ui/molecules/Brushaway';
import { Button } from '@ui/atoms/Button/Button';
import { translate } from '@utils/i18n';
const namespace = 'features.dashboards.inspection_assistant_insights_v2';
function TechDetailBrushaway({ tech, isOpen, onClose }) {
    var _a, _b;
    return (React.createElement(Brushaway, { controlledOpen: isOpen, onClose: onClose, minWidth: 720 },
        React.createElement(BrushawayHeader, { title: (_a = tech === null || tech === void 0 ? void 0 : tech.name) !== null && _a !== void 0 ? _a : '' }),
        React.createElement(BrushawayBody, { className: "tech-detail-brushaway" },
            React.createElement("div", { className: "tech-detail__scorecard-summary" },
                React.createElement("div", null,
                    React.createElement("span", { className: "tech-detail__label" }, translate('tech_perf.col_score', { namespace, defaultValue: 'Score' })),
                    React.createElement("strong", null, (tech === null || tech === void 0 ? void 0 : tech.currentScore) === null || (tech === null || tech === void 0 ? void 0 : tech.currentScore) === undefined ? '--' : `${tech.currentScore}/100`)),
                React.createElement("div", null,
                    React.createElement("span", { className: "tech-detail__label" }, translate('tech_perf.col_trend', { namespace, defaultValue: 'Trend' })),
                    React.createElement("strong", null, (_b = tech === null || tech === void 0 ? void 0 : tech.scoreTrend) !== null && _b !== void 0 ? _b : '--'))),
            (tech === null || tech === void 0 ? void 0 : tech.coachingRecommendationMd) ? (React.createElement(ReactMarkdown, null, tech.coachingRecommendationMd.replace(/\\n/g, '\n'))) : (React.createElement("p", null, (tech === null || tech === void 0 ? void 0 : tech.status) === 'failed'
                ? translate('tech_perf.detail.scorecard_failed', {
                    namespace,
                    defaultValue: 'Unable to generate a coaching recommendation.'
                })
                : translate('tech_perf.detail.no_scorecard_detail', {
                    namespace,
                    defaultValue: 'No coaching recommendation is available yet.'
                })))),
        React.createElement(BrushawayFooter, null,
            React.createElement(Button, { variant: "default", onClick: onClose }, translate('tech_perf.detail.close', { namespace })))));
}
export default TechDetailBrushaway;
